/* eslint-disable */
import Vue from 'vue'
import Oidc from 'oidc-client';
import AppStore from '@/store/modules/app/state'

var userManager = new Oidc.UserManager({
    userStore: new Oidc.WebStorageStateStore(),  
    authority: process.env.VUE_APP_IDP_URL,
    client_id: process.env.VUE_APP_API_IDP_CLIENT_ID,
    redirect_uri: window.location.origin + "/callback",
    response_type: "code",
    scope: process.env.VUE_APP_API_IDP_SCOPES,
    post_logout_redirect_uri: window.location.origin + "/index.html",
    silent_redirect_uri: window.location.origin + "/silent-renew",
    accessTokenExpiringNotificationTime: 10,
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: true,
    response_mode: "query"
});

///////////////////////////////
// events
///////////////////////////////
userManager.events.addAccessTokenExpiring(function () {
    //console.log("token expiring");
});

userManager.events.addAccessTokenExpired(function () {
    //console.log("token expired");
    userManager.signoutRedirect().catch(
        (err) => {
            console.error(err)
        }
    );
});

userManager.events.addSilentRenewError(function (e) {
    //console.log("silent renew error", e.message);
});

userManager.events.addUserUnloaded(function (e) {
    //console.log("user unloaded");
});

Vue.prototype.$security = {
    events: new Vue(),

    async signinSilentCallback(){
        const self = this;

        return new Promise(
            (resolve, reject) => {
                userManager.signinSilentCallback().then(
                    () => {
                        return resolve();
                    }
                ).catch(
                    (err) => {
                        return reject(err);
                    }
                );
            }
        );
    },

    async signinRedirectCallback(){
        const self = this;

        return new Promise(
            (resolve, reject) => {
                userManager.signinRedirectCallback().then(
                    (user) => {
                        return resolve(user);
                    }
                ).catch(
                    (err) => {
                        return reject(err);
                    }
                );
            }
        );
    },

    async getUser () {
        const self = this;
        return new Promise(
            (resolve, reject) => {
                userManager.getUser().then(
                    (user) => {
                        if (user == null) {
                            self.signIn();
                            return resolve(null);
                        } 
                        else{
                            if(!AppStore.isAuthenticated){
                                AppStore.isAuthenticated = true;
                                self.events.$emit("authenticated");
                            }

                            return resolve(user);
                        }
                    }
                ).catch(
                    (err) => {
                        return reject(err);
                    }
                );
            }
        );
    },

    async getUserId () {
        const self = this;
        
        return new Promise(
            (resolve, reject) => {
                userManager.getUser().then(
                    (user) => {
                        if (user != null) 
                            return resolve(user.profile.sub);
                        else 
                            return resolve(null);
                    }
                ).catch(
                    (err) => {
                        return reject(err);
                    }
                );
            }
        );
    },  

    signIn () {
        userManager.signinRedirect().catch(
            (err) => {
                console.error(err);
            }
        );
    },
  
    signOut () {    
        userManager.signoutRedirect().catch(
            (err) => {
                console.error(err);
            }
        );
    },

    async getAccessToken(){
        const self = this;

        return new Promise(
            (resolve, reject) => {
                userManager.getUser().then(
                    (user) => {
                        if (user == null) {
                            self.signIn();
                            return resolve(null);
                        } 
                        else
                            return resolve(user.access_token);
                    }
                ).catch(
                    (err) => {
                        return reject(err);
                    }
                );
            }
        );
    }
}